import { IAppletProfileSession } from "./types/applet-profile-session.interface";

class AppletProfileSession {
  appletFleetInstalled: boolean;
  appletProfileId: string;
  appletProfileTitle: string;
  segmentType: string;

  constructor(data: IAppletProfileSession = {
    applet_fleet_installed: false,
    applet_profile_id: "",
    applet_profile_title: "",
    segment_type: ""
  }) {
    this.appletFleetInstalled = data.applet_fleet_installed;
    this.appletProfileId = data.applet_profile_id;
    this.appletProfileTitle = data.applet_profile_title || '';
    this.segmentType = data.segment_type || '';
  }
}

export default AppletProfileSession;
